import { render, staticRenderFns } from "./StockMvtryComponent.vue?vue&type=template&id=2efbfb8a"
import script from "./StockMvtryComponent.vue?vue&type=script&lang=js"
export * from "./StockMvtryComponent.vue?vue&type=script&lang=js"
import style0 from "./StockMvtryComponent.vue?vue&type=style&index=0&id=2efbfb8a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports